module.exports = __webpack_public_path__ + "img/logo.4929c317.png";